/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 11/25/14
 * Time: 6:07 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var TopBarNotificationModel = require("models/userBarWidgets/TopBarNotificationModel");
    var TopBarNotificationView = require("views/userBarWidgets/TopBarNotificationView");

    var TopBarNotificationController = Marionette.Controller.extend({
        initialize: function (options) {
            this.LE = options.application;
            this._setTopBarNotificationRegion();
            this._setEventListeners();

        },
        _setEventListeners: function () {
            this.LE.vent.on("topBarNotificationController:newNotification", this._setNewNotification,this);
            this.LE.vent.on("topBarNotificationController:removeNotification", this._removeNotification,this);
            this.topBarNotificationView.on("removeNotification", this._removeNotification,this);
        },
        _setTopBarNotificationRegion:function(){
            this.topBarNotificationModel = new TopBarNotificationModel();
            this.topBarNotificationView = new TopBarNotificationView({
                model:this.topBarNotificationModel
            });
            this.LE.vent.trigger("userBarWidgetsLayoutController:showRegion",{
                //todo: move region names to const
                region:"topBarNotification",
                view:this.topBarNotificationView
            });
        },

        _setNewNotification: function (options) {
            options=options||{};
            var notification= {
                    id: options.id,
                    type: options.type,
                    contentOptions: options.contentOptions,
                    viewOptions:options.viewOptions,
                    onShow: options.onShow,
                    onClose: options.onClose,
                    removeOnClose: options.removeOnClose
                };
            this.topBarNotificationModel.set("notification",notification);

        },
        _removeNotification: function (options) {
            this.topBarNotificationModel.set("notification",null);
        }

    });
    return TopBarNotificationController;
});